import { useApplicationContext } from '../../../../../../provider'

export default (props: any) => {
  const { nonce } = useApplicationContext()
  const integrationType = props.options.find(
    (option: any) => option.name === 'integration',
  ).value
  const tds = props.buttons.includes('payment-buttons_3ds')

  let selectedSources = props.buttons.map((button: string) =>
    button.split('payment-buttons_')[1].toUpperCase(),
  )

  return `<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    
    <style>
    .paypal-button-container {
        border-radius: 5px;
        max-width: 500px;
        width: 100%;
        margin: 0 auto;
    }
    
    .card_container {
        border-radius: 5px;
        max-width: 500px;
        width: 100%;
        margin: 0 auto;
    }
    
    .card_field {
        width: 100%;
        padding: 12px;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
        margin-top: 6px;
        margin-bottom: 16px;
        resize: vertical;
        height: 40px;
        background: white;
        font-size: 17px;
        color: #3a3a3a;
        font-family: helvetica, tahoma, calibri, sans-serif;
    }
    
    .card_field_50 {
        width: 50%;
        padding: 12px;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
        margin-top: 6px;
        margin-bottom: 16px;
        resize: vertical;
        height: 40px;
        background: white;
        font-size: 17px;
        color: #3a3a3a;
        font-family: helvetica, tahoma, calibri, sans-serif;
    }
    
    .card_field_75 {
        width: 75%;
        padding: 12px;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
        margin-top: 6px;
        margin-bottom: 16px;
        resize: vertical;
        height: 40px;
        background: white;
        font-size: 17px;
        color: #3a3a3a;
        font-family: helvetica, tahoma, calibri, sans-serif;
    }
    
    .row {
        display: -ms-flexbox;
        /* IE10 */
        display: flex;
        -ms-flex-wrap: wrap;
        /* IE10 */
        flex-wrap: wrap;
        margin: 0 -16px;
    }
    
    .col-25 {
        -ms-flex: 25%;
        /* IE10 */
        flex: 25%;
    }
    
    .col-50 {
        -ms-flex: 50%;
        /* IE10 */
        flex: 50%;
    }
    
    input[type=text],
    select,
    textarea {
        width: 100%;
        padding: 12px;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
        margin-top: 6px;
        margin-bottom: 16px;
        resize: vertical;
        height: 40px;
        background: white;
        font-size: 17px;
        color: #3a3a3a;
        font-family: helvetica, tahoma, calibri, sans-serif;
    }
    
    input[type=submit] {
        background-color: #4CAF50;
        color: white;
        padding: 12px 20px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
    }
    
    .message_container {
        border-radius: 5px;
        background: #FFFFFF;
        font-size: 13px;
        font-family: monospace;
        padding: 20px;
    }
    
    #loading {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: fixed;
        display: block;
        opacity: 0.7;
        background-color: #fff;
        z-index: 99;
        text-align: center;
    }
    
    #loading-image {
        position: absolute;
        z-index: 15;
        top: 50%;
        left: 50%;
        margin: -100px 0 0 -150px;
    }
    
    .spinner {
        position: fixed;
        top: 50%;
        left: 50%;
        margin-left: -50px;
        /* half width of the spinner gif */
        margin-top: -50px;
        /* half height of the spinner gif */
        text-align: center;
        z-index: 1234;
        overflow: auto;
        width: 100px;
        /* width of the spinner gif */
        height: 102px;
        /* height of the spinner gif +2px to fix IE8 issue */
    }
    
    .button_container {
        display: flex;
        justify-content: center;
    }
    
    .split_title {
        width: 100%;
        text-align: center;
        border-bottom: 1px solid #000;
        line-height: 0.1em;
        margin: 10px 0 20px;
        max-width: 500px;
        width: 100%;
        margin-top: 16px;
    }
    
    .split_title_span {
        padding: 0 10px;
        font-family: 'PayPal Open';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        margin-top: 6px;
    }
    button {
        width: 229px;
        height: 49px;
        background: #001435;
        border: 1px dotted black;
        font-size: 17px;
        color: #3a3a3a;
        padding: 12px 20px;
        border-radius: 4px;
        cursor: pointer;
        margin: 0 auto;
    }
    
    .button-pill {
        border-radius: 24px;
    }
    .btn_small {
        width: 130px;
        height: 39px;
        background: lightblue;
        border: 1px dotted black;
        font-size: 14px;
        color: #3a3a3a;
    }
    
    .btn_small:hover {
        background-color: powderblue;
    }
    .terms_span {
        font-family: 'PayPal Open';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #001435;
        flex: none;
        order: 0;
        flex-grow: 0;

    }

    .tooltip {
      position: relative;
    }
    .tooltip .tooltiptext {
      visibility: hidden;
      overflow: visible;
      width: 270px;
      background: #FFFFFF;
      padding: 16px;
      gap: 8px;
      border-radius: 4px;
      color: #2c2e2f;
      text-align: left;
      position: absolute;
      z-index: 1;
      bottom: 150%;
      left: -220%;
      margin-left: -60px;
      opacity: 0;
      filter:drop-shadow(0 0 16px rgba(0,0,0,0.15));
      font-family: 'PayPalOpen-Regular', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    }
    
    .tooltip .tooltiptext::after {
      top: 100%;
      left: 50%;
      border-width: 8px;
      border-style: solid;
      border-color: #FFFFFF transparent transparent transparent;
      height: 122px;
      font-family: PayPal Open;
      font-size: 18px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
    }
    .tooltip:hover .tooltiptext {
      visibility: visible;
      opacity: 1;
      z-index: 9999;
    }
    </style>
    <script type="text/javascript" nonce="${nonce}">
      const fis = '${selectedSources.join(',')}';
      const shape = '${props.buttonStyle}';
      const integrationType = '${integrationType}';
      const tds = '${tds}';

      const client_id = 'ARo8VkLiF5aVnlHgZ1SwTPt7Pq218nO7pjJ68qLZ6jcl5JLQEenqJ8nAixxfh6btGoC8v8zASZ2awDwb';
      
      async function test() {
          const client_token = '${props.client_token}';
          const script = document.createElement('script');
          script.src = 'https://www.paypal.com/sdk/js?client-id='+client_id+'&locale=en_US&vault=false&enable-funding=venmo&currency=USD&buyer-country=US&components=buttons,hosted-fields';
          script.setAttribute('data-client-token', client_token);
          ${nonce ? `script.setAttribute('data-csp-nonce', '${nonce}');` : ''}
          document.head.appendChild(script);
          script.onload = function() {
            getApp();
            const form = document.getElementById("card-form");
            form.addEventListener("submit", onSubmit);
          }
      };

      test();
      const onSubmit = (event) => {
        event.preventDefault();
        try{
          const cardNumberInput =  document.getElementById("card-number").value;
          const cardExpiration = document.getElementById("card-expiration-date").value;
          const cardCvv = document.getElementById("card-cvv").value;
          
          if(cardNumberInput === '4005519200000004' && cardExpiration === '09/2025' && cardCvv === '567'){
            return window.parent.postMessage({ action: "done", fundingSource: 'fundingSource',integrationType, tds: 'false' });
          }
          
          if(cardNumberInput === '4868719460707704' && cardExpiration === '01/2025' && cardCvv === '123'){
            return window.parent.postMessage({ action: "done", fundingSource: 'fundingSource',integrationType, tds: 'true' });
          }
          
          return window.parent.postMessage({ action: "error", fundingSource: 'fundingSource',integrationType, tds });
        }catch(error){
          console.log(error);
        }
      }
      
      function getApp(){
        ////////////advanced-checkout.js content
        const selectedShape = ["rect", "pill"].includes(shape) ? shape : "rect";
  
        const fiMap = {
          PAYPAL: paypal.FUNDING.PAYPAL,
          PAYLATER: paypal.FUNDING.PAYLATER,
          VENMO: paypal.FUNDING.VENMO,
        }
        
        const fundingSources = fis
        .split(",")
        .map((f) => fiMap[f])
        .filter(Boolean);
        
        const fundingSourceColors = {
          VENMO: "blue",
          PAYPAL: "gold",
          PAYLATER: "gold",
        };
        
        for (const fundingSource of Object.keys(fiMap).filter(source => fis.split(",").includes(source) )) {
        
         paypal
         .Buttons({
            fundingSource: fiMap[fundingSource],
           
            style: {
              shape: selectedShape,
              color: fundingSourceColors[fundingSource],
              label: "paypal"
            },
        
            createOrder: function (data, actions) {
              const createOrderPayload = {
                purchase_units: [
                  {
                    amount: {
                      value: "88.44",
                    },
                  },
                ],
              };
        
              return actions.order.create(createOrderPayload);
            },
            
            onApprove: function (data, actions) {
              
            },
         })
         .render("#paypal-button-container");
        }
        
        // If this returns false or the card fields aren't visible, see Step #1.
        if (paypal.HostedFields.isEligible()) {
          let orderId;
        
          // Renders card fields
          paypal.HostedFields.render({
            createOrder: () => {
              const createOrderPayload = {
                purchase_units: [
                  {
                    amount: {
                      value: "88.44",
                    },
                  },
                ],
              };
              order = actions.order.create(createOrderPayload); 
              return order
            },
            styles: {
              ".valid": {
                color: "green",
              },
              ".invalid": {
                color: "red",
              },
            },
            fields: {
              number: {
                selector: "#card-number",
                placeholder: "Card number",
              },
              cvv: {
                selector: "#cvv",
                placeholder: "CVV",
              },
              expirationDate: {
                selector: "#expiration-date",
                placeholder: "Expiration",
              },
            },
          }).then((cardFields) => {
            document.querySelector("#card-form").addEventListener("submit", (event) => {
              event.preventDefault();
            });
          });
        } else {
          // Hides card fields if the merchant isn't eligible
          document.querySelector("#card-form").style = "display: none";
        }
        
        ////////////
      }
  </script>
  </head>
  <style>
    .paypal-buttons {
      margin-top: 15px;
      margin-right: 15px;
    }
  </style>
  <body>
  <div style="width: 300px; margin: auto">
    <div id="paypal-button-container" class="paypal-button-container"></div>
    <div style='display:flex; flex-direction: row'>
      <h2 class='split_title'></h2>
      <span class='split_title_span'> or </span>
      <h2 class='split_title'></h2>
    </div>
    <div class="card_container">
    <form id="card-form">
      <input
        type="text"
        id="card-number"
        class="card-field"
        name="card-number"
        autocomplete="off"
        placeholder="Card number"
        style="font-family:helvetica; font-size:14px; height: 50px; padding-left: 25px;"
      />  
      <div style="display: flex; flex-direction: row;">
        <div style="flex: 1">
          <input
            type="text"
            id="card-expiration-date"
            name="card-expiration-date"
            autocomplete="off"
            placeholder="Expiration"
            class="card-field"
            style=" font-family:helvetica; font-size:14px; height: 50px"
          />
        </div>
        <div style="flex: 1; margin-left: 24px; position:relative">
          <input
            type="text"
            id="card-cvv"
            name="card-cvv"
            autocomplete="off"
            placeholder="CVV"
            class="card-field"
            style="font-family:helvetica; font-size:14px; height: 50px;"
          />
          <div style="position: absolute;right: 0.2rem;
            top: 0.7rem;
            width: 2.6rem;
            height: 2.6rem;
            border-radius: 0.3rem; display:flex; align-items:center; justify-content: center;">
            <span class="tooltip">
              <svg xmlns="http://www.w3.org/2000/svg" fill="#003087" viewBox="0 0 24 24" width="1.5em" height="1.5em" data-ppui="true"><path fill-rule="evenodd" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0zm-9.578 1.54h1.164c.168 0 .264-.097.276-.277.06-.564.324-.84.912-1.296l.108-.084c.756-.588 1.164-1.296 1.164-2.172 0-1.344-1.032-2.412-2.916-2.412-1.788 0-2.868.96-3.012 2.52-.012.192.096.288.276.288h1.32c.168 0 .264-.096.288-.276.06-.648.42-1.02 1.08-1.02.636 0 1.02.408 1.02.936 0 .516-.276.876-.552 1.128l-.456.42c-.672.612-.912 1.032-.948 1.956 0 .192.096.288.276.288zM12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" clip-rule="evenodd" data-ppui="true"></path></svg>
              <span class="tooltiptext">
              <img src="https://www.paypalobjects.com/paypal-ui/components/csc-card/csc-card-front.svg"
              style="width: 4rem;"/><br/>
              The CSC is the 3-digit number on the back of your card.
              </span>
            </span>     
          </div>
        </div>
      </div>   
      <div>
        <input
          type="text"
          id="card-holder-name"
          name="card-holder-name"
          autocomplete="off"
          placeholder="Name on card"
          class="card-field"
          style=" font-family:helvetica; font-size:14px; height: 50px"
        />
        <div>
          <input
            type="text"
            id="card-billing-address-country"
            name="card-billing-address-country"
            autocomplete="off"
            placeholder="Zip code"
            style=" font-family:helvetica; font-size:14px; height: 50px"
          />
        </div>
      </div>
      <button value="submit" id="submit" class="btn ${
        props.buttonStyle === 'pill' ? 'button-pill' : ''
      }" style="width:100%; height:48px;color:white">Place Order</button>
    </form>
    <br />
    </div>
    </div>
    <div style="display:flex;
      justify-content: center;
      align-items: center;"
    >
      <span class="terms_span">By clicking Place Order, you agree to <b>Terms & Conditions</b></span>
    <div>
  </body>
  </html>`
}
